// Pure edge extraction for the TOC "Overzicht" chain board. Walks the same
// link arrays the navigator uses (see tocNavigatorChain.js) and returns every
// live connection as a flat edge list. Links pointing at IDs that are not in
// the model (dangling references, soft-deleted upstream docs) are skipped —
// an edge always has two live endpoints.

/**
 * @typedef {object} ChainEdge
 * @property {string} from - Source entity ID (upstream step)
 * @property {string} to - Target entity ID (downstream step)
 * @property {'doel-act'|'act-mech'|'mech-eff'} kind - Which chain hop this edge is
 */

/**
 * @param {{ byStep: Record<string, Array<{id: string, raw: object}>>, byId: Map<string, object> } | null} model
 *   Navigator model from buildNavigatorModel.
 * @returns {ChainEdge[]}
 */
const buildChainEdges = (model) => {
  if (!model || !model.byId) return [];
  const edges = [];
  const seen = new Set(); // a link ID can occur twice in one array — dedupe
  const has = (id) => model.byId.has(id);

  const pushAll = (ids, make) => {
    (Array.isArray(ids) ? ids : []).forEach((id) => {
      const edge = make(id);
      const key = `${edge.from}→${edge.to}`;
      if (seen.has(key) || !has(edge.from) || !has(edge.to)) return;
      seen.add(key);
      edges.push(edge);
    });
  };

  model.byStep.act.forEach((act) => {
    pushAll(act.raw.Targetgroup, (doelId) => ({ from: doelId, to: act.id, kind: "doel-act" }));
  });
  model.byStep.mech.forEach((mech) => {
    pushAll(mech.raw.Activity, (actId) => ({ from: actId, to: mech.id, kind: "act-mech" }));
    pushAll(mech.raw.Effect, (effId) => ({ from: mech.id, to: effId, kind: "mech-eff" }));
  });

  return edges;
};

export default buildChainEdges;
